module.exports = __webpack_public_path__ + "img/already-signed.d12871ff.png";